<template>
    <div class="outer" v-if="showBool">
        <van-picker
            show-toolbar
            title="请选择"
            :itemHeight="itemHeight"
            valueKey="value"
            :columns="picker"
            @change="onChange"
            @cancel="handlePickerCancel"
            @confirm="handlePickerConfirm"
        />
    </div>
</template>

<script>
import api from '../../../api/api'

export default {
  name: 'select-picker',
  props: {
    position: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      defaultValue: '',
      picker: [],
      showBool: false,
      pickerType: 'phoneArea',
      citys: {},
      itemHeight: 44,
      schools: {},
      params: ''// 返回参数名
    }
  },
  mounted () {
    this.itemHeight = window.dpr * 44
  },
  methods: {
    showFun (pickerType, defaultValue, params) {
      let me = this
      if (defaultValue) {
        me.defaultValue = defaultValue
      }
      if (pickerType) {
        me.pickerType = pickerType
      }
      if (params) {
        me.params = params
      }
      if (me.pickerType == 'phoneArea') { // 电话区号
        me.getPhoneArea()
      } else if (me.pickerType == 'sex') { // 性别
        me.getSex()
      } else if (me.pickerType == 'sex2') { // 性别-报名表单
        me.getSex2()
      } else if (me.pickerType == 'location') { // 所在地
        me.getLocation()
      } else if (me.pickerType == 'birthdayYear' || me.pickerType == 'workBegin' || me.pickerType == 'workEnd') { // 出生日期//在读时段（开始）//在读时段（结束）
        me.getYearMonth()
      } else if (me.pickerType == 'workStatus') { // 目前状态
        me.getWorkStatus()
      } else if (me.pickerType == 'workStatus2') { // 个人状态-报名表单
        me.getWorkStatus2()
      } else if (me.pickerType == 'workExperience') { // 工作年限
        me.getWorkExperience()
      } else if (me.pickerType == 'degree') { // 学历(最高学历)
        me.getDegree()
      } else if (me.pickerType == 'school') { // 毕业院校（在读院校）
        me.getSchool()
      } else if (me.pickerType == 'industry') { // 所属行业
        me.getIndustry()
      } else if (me.pickerType == 'grade') { // 年级
        me.getGrade()
      } else if (me.pickerType == 'cardType') { // 证件类型
        me.getCardType()
      }
      setTimeout(() => {
        me.showBool = true
      }, 200)
    },
    onChange (picker, values) {
      let me = this
      if (me.pickerType == 'location') {
        picker.setColumnValues(1, me.citys[values[0]])
      } else if (me.pickerType == 'school') {
        picker.setColumnValues(1, me.schools[values[0]])
      }
    },
    handlePickerCancel (data) { // 取消
      this.$emit('handlePickerCancel', data)
      this.showBool = false
    },
    handlePickerConfirm (data) { // 确定
      this.showBool = false
      this.$emit('handlePickerConfirm', data, this.pickerType, this.params)
    },
    getPhoneArea () {
      let me = this
      api.schoolUrl({type: 'international_code'}).then(res => {
        me.common.axiosSuccessFun({
          this: me,
          callBack () {
            var list = JSON.parse(res.data.data.international_code)
            var arr = []
            var iIndex = 0
            list.forEach((item, index) => {
              arr.push({value: '+' + item[2] + ' ' + item[0] + item[1], id: '+' + item[2]})
              if (me.defaultValue != '' && me.defaultValue == '+' + item[2]) {
                iIndex = index
              }
            })
            me.picker = [
              {
                values: arr,
                defaultIndex: iIndex
              }
            ]
          }
        }, res.data)
      }).catch((res) => {
        me.common.axiosFailFun({
          this: me
        }, res)
      })
    },
    getSex () {
      let me = this
      let iIndex = 0
      me.picker = [
        {
          values: [
            {value: '女', id: '0'},
            {value: '男', id: '1'},
            {value: '你猜', id: '2'}
          ],
          defaultIndex: Number(me.defaultValue)
        }
      ]
    },
    getSex2 () {
      let me = this
      let iIndex = 0
      me.picker = [
        {
          values: [
            {value: '女', id: '0'},
            {value: '男', id: '1'}
          ],
          defaultIndex: Number(me.defaultValue)
        }
      ]
    },
    getLocation () {
      let me = this
      let citys = {}
      api.schoolUrl({type: 'province,city'}).then(res => {
        me.common.axiosSuccessFun({
          this: me,
          callBack () {
            var province = JSON.parse(res.data.data.province)
            var city = JSON.parse(res.data.data.city)
            var Obj = {}
            var activeProvince = '北京'
            var cityIndex = 0
            var provinceIndex = 0
            var k = 0
            for (var item in province) {
              Obj[item] = []
              for (var i in city) {
                var arr = []
                for (var j in city[i]) {
                  if (city[i][j].name == me.defaultValue) {
                    cityIndex = arr.length
                  }
                  arr.push(city[i][j].name)
                }
                if (province[item].id == i) {
                  Obj[item] = arr
                  for (var j in city[i]) {
                    if (city[i][j].name == me.defaultValue) {
                      provinceIndex = k
                      activeProvince = item
                    }
                  }
                }
              }
              if (Obj[item].length == 0) {
                Obj[item] = [item]
                if (item == me.defaultValue) {
                  provinceIndex = k
                  activeProvince = item
                }
              }
              k++
            }
            me.citys = Obj

            me.picker = [
              {
                values: Object.keys(me.citys),
                className: 'column1',
                defaultIndex: provinceIndex
              },
              {
                values: me.citys[activeProvince],
                className: 'column2',
                defaultIndex: cityIndex
              }
            ]
          }
        }, res.data)
      }).catch((res) => {
        me.common.axiosFailFun({
          this: me
        }, res)
      })
    },
    getYearMonth () {
      let thisYear = new Date().getFullYear() + 8
      let arr_year = []
      let yearIndex = 0
      let monthIndex = 0
      let defaultArr = this.defaultValue.split('-')
      for (var i = 1940; i <= thisYear; i++) {
        arr_year.push(i)
        if (defaultArr[0] == i) {
          yearIndex = arr_year.length - 1
        }
      }
      let arr_month = []
      for (var i = 1; i < 13; i++) {
        arr_month.push(i < 10 ? '0' + i : i + '')
        if (defaultArr[1] == i) {
          monthIndex = arr_month.length - 1
        }
      }
      this.picker = [
        {
          values: arr_year,
          className: 'column1',
          defaultIndex: yearIndex == 0 ? arr_year.length : yearIndex
        },
        {
          values: arr_month,
          className: 'column2',
          defaultIndex: monthIndex
        }
      ]
    },
    getWorkStatus () {
      let me = this
      let iIndex = 0
      let arr = [
        {value: '在职', id: '在职'},
        {value: '在读', id: '在读'},
        {value: '自由职业者', id: '自由职业者'},
        {value: '其他', id: '其他'}
      ]
      arr.forEach((item, index) => {
        if (item.id == me.defaultValue) {
          iIndex = index
        }
      })
      me.picker = [{
        values: arr,
        defaultIndex: iIndex
      }]
    },
    getWorkStatus2 () {
      let me = this
      let iIndex = 0
      let arr = [
        {value: '在职', id: '在职'},
        {value: '在读', id: '在读'},
        {value: '自由职业者', id: '自由职业者'}
      ]
      arr.forEach((item, index) => {
        if (item.id == me.defaultValue) {
          iIndex = index
        }
      })
      me.picker = [{
        values: arr,
        defaultIndex: iIndex
      }]
    },
    getWorkExperience () {
      let me = this
      let iIndex = 0
      let arr = [
        {value: '1年内', id: '1年内'},
        {value: '1-3年', id: '1-3年'},
        {value: '3-5年', id: '3-5年'},
        {value: '5年以上', id: '5年以上'}

      ]
      arr.forEach((item, index) => {
        if (item.id == me.defaultValue) {
          iIndex = index
        }
      })
      me.picker = [
        {
          values: arr,
          defaultIndex: iIndex
        }
      ]
    },
    getDegree () {
      let me = this
      let iIndex = 0
      let arr = [
        {value: '高中/中专/中技及以下', id: '高中/中专/中技及以下'},
        {value: '大专及同等学历', id: '大专及同等学历'},
        {value: '本科/学士及同等学历', id: '本科/学士及同等学历'},
        {value: '硕士/研究生及同等学历', id: '硕士/研究生及同等学历'},
        {value: '博士及以上', id: '博士及以上'},
        {value: '其他', id: '其他'}
      ]
      arr.forEach((item, index) => {
        if (item.id == me.defaultValue) {
          iIndex = index
        }
      })
      me.picker = [
        {
          values: arr,
          defaultIndex: iIndex
        }
      ]
    },
    getSchool () {
      let me = this
      let schools = {}
      api.schoolUrl({type: 'school_address,school'}).then(res => {
        me.common.axiosSuccessFun({
          this: me,
          callBack () {
            var province = JSON.parse(res.data.data.school_address)
            var school = JSON.parse(res.data.data.school)
            var Obj = {}
            var activeProvince = '安徽省'
            var schoolIndex = 0
            var provinceIndex = 0
            var k = 0
            for (var item in province) {
              for (var i in school) {
                if (province[item][0] == i) {
                  Obj[province[item][1]] = school[i]
                  school[i].forEach((j, index) => {
                    if (j == me.defaultValue) {
                      activeProvince = province[item][1]
                      provinceIndex = k
                      schoolIndex = index
                    }
                  })
                }
              }
              k++
            }
            me.schools = Obj
            me.picker = [
              {
                values: Object.keys(me.schools),
                className: 'column1',
                defaultIndex: provinceIndex
              },
              {
                values: me.schools[activeProvince],
                className: 'column2',
                defaultIndex: schoolIndex
              }
            ]
          }
        }, res.data)
      }).catch((res) => {
        me.common.axiosFailFun({
          this: me
        }, res)
      })
    },
    getIndustry () {
      let me = this
      let iIndex = 0
      let arr = [
        {
          id: '互联网/IT/电子/通信',
          value: '互联网/IT/电子/通信'
        },
        {
          id: '金融保险业',
          value: '金融保险业'
        },
        {
          id: '教育培训/科研',
          value: '教育培训/科研'
        },
        {
          id: '卫生及社会工作',
          value: '卫生及社会工作'
        },
        {
          id: '公共管理/社会保障',
          value: '公共管理/社会保障'
        },
        {
          id: '其他',
          value: '其他'
        }

      ]
      arr.forEach((item, index) => {
        if (item.id == me.defaultValue) {
          iIndex = index
        }
      })
      me.picker = [
        {
          values: arr,
          defaultIndex: iIndex
        }
      ]
    },
    getGrade () {
      let me = this
      let iIndex = 0
      let arr = [
        {
          id: '本科/大一',
          value: '本科/大一'
        }, {
          id: '本科/大二',
          value: '本科/大二'
        }, {
          id: '本科/大三',
          value: '本科/大三'
        }, {
          id: '本科/大四',
          value: '本科/大四'
        }, {
          id: '本科/大五',
          value: '本科/大五'
        }, {
          id: '硕士/研一',
          value: '硕士/研一'
        }, {
          id: '硕士/研二',
          value: '硕士/研二'
        }, {
          id: '硕士/研三',
          value: '硕士/研三'
        }, {
          id: '博士/博一',
          value: '博士/博一'
        }, {
          id: '博士/博二',
          value: '博士/博二'
        }, {
          id: '博士/博三',
          value: '博士/博三'
        }, {
          id: '博士/博四',
          value: '博士/博四'
        }, {
          id: '博士/博五',
          value: '博士/博五'
        }, {
          id: '其他',
          value: '其他'
        }
      ]
      arr.forEach((item, index) => {
        if (item.id == me.defaultValue) {
          iIndex = index
        }
      })
      me.picker = [
        {
          values: arr,
          defaultIndex: iIndex
        }
      ]
    },
    getCardType () {
      let me = this
      let iIndex = 0
      let arr = [
        {
          id: '1',
          value: '身份证'
        }, {
          id: '4',
          value: '护照'
        }, {
          id: '2',
          value: '港澳居民来往通行证'
        }, {
          id: '3',
          value: '台湾居民来往大陆通行证'
        }
      ]
      arr.forEach((item, index) => {
        if (item.id == me.defaultValue) {
          iIndex = index
        }
      })
      me.picker = [
        {
          values: arr,
          defaultIndex: iIndex
        }
      ]
    }
  }
}
</script>

<style>
    .outer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 100vh;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
    }

    .van-picker {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 0;
    }

    .van-picker__toolbar {
        height: 88px;
        line-height: 88px;
    }

    .van-picker__cancel {
        color: red;
    }

    .van-picker__confirm {
        color: rgb(77, 166, 255);
    }

    .van-picker__cancel, .van-picker__confirm {
        padding: 0 30px;
        font-size: 28px;
    }

    .van-picker__title {
        font-size: 32px;
    }

    .van-picker-column__item {
        font-size: 32px;
    }

    /*}*/
</style>



// WEBPACK FOOTER //
// src/components/common/picker/select-picker.vue